import nodeStates from '../constants/nodeStates';
import nodeStyles from '../constants/nodeStyles';
import findLast from 'lodash/findLast';
import slice from 'lodash/slice';
import nodeDescriptions from '../constants/nodeDescriptions';

function nodeSortOrderOrDefault(node) {
    if (!node) return -1;

    return node.sortOrder;
}

function getLastNodeByStateSortOrder(timelineNodes, state) {
    return nodeSortOrderOrDefault(
        findLast(timelineNodes, (x) => x.state === state)
    );
}

export function isTimeLineHealthy(timelineNodes) {
    return (
        sortOrderOfLastCompletedBag(timelineNodes) >=
        sortOrderOfNodeAtFault(timelineNodes)
    );
}

export function sortOrderOfLastCompletedBag(timelineNodes) {
    return getLastNodeByStateSortOrder(timelineNodes, nodeStates.completedBag);
}

export function sortOrderOfLastCompletedFlight(timelineNodes) {
    return getLastNodeByStateSortOrder(
        timelineNodes,
        nodeStates.completedFlight
    );
}

export function sortOrderOfLastCompletedReflight(timelineNodes) {
    return getLastNodeByStateSortOrder(
        timelineNodes,
        nodeStates.completedReflight
    );
}

export function sortOrderOfArrivalNodeAtStation(timelineNodes) {
    const arrivalNode = timelineNodes.find(
        (x) => x.description === nodeDescriptions.arrival
    );
    if (arrivalNode != null) {
        return nodeSortOrderOrDefault(arrivalNode);
    }
    return -1;
}

export function sortOrderOfNodeAtFault(timelineNodes) {
    const lastCompletedBagSortOrder = getLastNodeByStateSortOrder(
        timelineNodes,
        nodeStates.completedBag
    );

    if (lastCompletedBagSortOrder === -1) {
        return nodeSortOrderOrDefault(
            timelineNodes.find((x) => x.state === nodeStates.missed)
        );
    }

    const index = timelineNodes.findIndex(
        (x) => x.sortOrder === lastCompletedBagSortOrder
    );
    const nodes = slice(timelineNodes, index);
    return nodeSortOrderOrDefault(
        nodes.find((x) => x.state === nodeStates.missed)
    );
}
